import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import bareNoCover from "./components/bare-no-cover";
import bareCover from "./components/bare-cover";
import floatingNoCover from "./components/floating-no-cover";
import floatingCover from "./components/floating-cover";

const principle: Slide = {
  description:
    "Choose between airborne and impact sound insulation of floors. Select different floor states and see how a floating floor and covers can reduce impact sound. Listen to sounds of the standard tapping machine, a child (25 kg) jumping and a man (120 kg) thumping on the floor, recorded in the source room above and in the receiving room below. Use headphones. Leave the volume setting on your device as set earlier.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 9],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<strong>IMPACT insulation</strong>",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                    fontSize: "14px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controlsPosition: "top",
                controls: [
                  {
                    type: "button",
                    options: {},
                    items: [
                      { name: "Bare, no cover" },
                      { name: "Bare, covered" },
                      { name: "Floating, no cover" },
                      { name: "Floating, covered" },
                    ],
                  },
                ],
                extraContent: [[], [], [], []],
                components: [bareNoCover, bareCover, floatingNoCover, floatingCover],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
